module.exports = __webpack_public_path__ + "static/customerbg3-27bd6368e9c6fa7ebbf44997757b5796.jpg";